module.exports = __webpack_public_path__ + "static/media/icono_banda.a7ba68ce.svg";